module.exports = __webpack_public_path__ + "static/media/sociabilidade.be2a22e9.svg";